import { Helmet } from "react-helmet-async";
import { API } from "@/lib/api";

const SITE_NAME = "Orphion Global HR";
const SITE_DEFAULT_TITLE =
  "Orphion Global HR — Recruitment & Fractional HR for IT and Non-IT companies";
const SITE_DEFAULT_DESCRIPTION =
  "Orphion Global HR is a boutique recruitment and fractional HR practice for IT and non-IT companies scaling past their first inflection. Five primary practices: Recruitment, HR Consulting, HR Operations, Employer Branding, GCC Support (fractional HR services and HR Tech Consulting included under HR Consulting).";

const computeOgImage = (title, kicker) => {
  const q = new URLSearchParams({
    title: title || "Orphion",
    kicker: kicker || "orphionglobalhr.com",
  }).toString();
  return `${API}/og?${q}`;
};

/**
 * Reusable per-page SEO. Injects <title>, meta description, canonical,
 * Open Graph and Twitter tags. Pass an array of JSON-LD objects for structured data.
 */
export const Seo = ({
  title,
  description = SITE_DEFAULT_DESCRIPTION,
  path = "",
  image,
  kicker,
  type = "website",
  noIndex = false,
  jsonLd = [],
}) => {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_DEFAULT_TITLE;
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "https://orphionglobalhr.com";
  const url = `${origin}${path || (typeof window !== "undefined" ? window.location.pathname : "")}`;
  const finalImage = image || computeOgImage(title || SITE_NAME, kicker);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,follow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={finalImage} />

      {/* Structured data */}
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
